export default __webpack_public_path__ + "static/neue-haas-grotesk-text-66-medium-italic-8c05721ef9c1b53beb60e5cb3da0446c.woff2";